import React, { useEffect, useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import {
  Chip,
  FormControl,
  IconButton,
  InputBase,
  Stack,
  SxProps,
  Tooltip,
} from '@mui/material';
import { useForm } from 'react-hook-form';

import RISelectComponent from '../Components/SelectComponent';

interface IProps {
  label: string;
  onChange?: (value: string[]) => void;
  options: any;
  labelKey?: string;
  valueKey?: string;
  value?: any;
  isLoading?: boolean;
  groupedOptions?: boolean;
  sx?: SxProps;
}

const TableSearchSelectInput: React.FC<IProps> = ({
  label,
  options,
  onChange,
  labelKey = 'name',
  valueKey = 'displayName',
  value = [],
  isLoading,
  groupedOptions,
  sx,
}) => {
  const [selectedValue, setSelectedValue] = useState<string[]>(value);

  const { control, watch, setValue } = useForm({
    defaultValues: {
      filter_values: selectedValue,
    },
  });

  const selectedFilterValue = watch('filter_values');

  useEffect(() => {
    if (JSON.stringify(selectedValue) !== JSON.stringify(selectedFilterValue)) {
      setSelectedValue(selectedFilterValue ?? []);
    }
    if (selectedFilterValue?.length === 0) {
      onChange?.([]);
    }
  }, [selectedFilterValue]);

  const triggerSearch = () => {
    onChange?.(selectedValue);
  };

  return (
    <Stack direction="row" alignItems="center" width="100%">
      <FormControl
        sx={{ m: 0, minWidth: 150, maxWidth: 230, ...sx }}
        className="select-filter"
      >
        <RISelectComponent
          name="filter_values"
          control={control}
          isMultiselect
          valueKey={valueKey}
          labelKey={labelKey}
          options={options || []}
          groupedOptions={groupedOptions}
          disabled={isLoading}
          renderCustomComponent={(val: any, props) => (
            <Tooltip title={val?.[labelKey] || val}>
              <Chip {...props} label={val?.[labelKey] || val} />
            </Tooltip>
          )}
          isFilterCustomComponent={true}
          CustomInput={(params) => (
            <InputBase
              placeholder={label}
              disabled={isLoading}
              sx={{
                width: '100%',
                display: 'flex',
                flexWrap: 'nowrap',
                gap: 0.5,
                height: '55px',
                alignItems: 'center',
                overflow: 'scroll',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
                pointerEvents: isLoading ? 'none' : '',
                opacity: isLoading ? 0.6 : '',
              }}
              {...params.InputProps}
              inputProps={{
                ...params.inputProps,
                'aria-label': 'Without label',
              }}
            />
          )}
          optionsSx={{ label: { maxWidth: '190px' } }}
        />
      </FormControl>
      <IconButton
        onClick={triggerSearch}
        disabled={isLoading}
        size="small"
        sx={{ height: '2rem' }}
      >
        <SearchIcon />
      </IconButton>
    </Stack>
  );
};

export default TableSearchSelectInput;
